"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Bootstrap_1 = require("../Bootstrap");
var Helpers_1 = require("../Helpers");
var constants_1 = require("./constants");
var defaultValues = constants_1.default;
var Bug = /** @class */ (function () {
    function Bug(bootstrap, options) {
        if (bootstrap === void 0) { bootstrap = Bootstrap_1.default.getInstance(); }
        this.NEAR_TOP_EDGE = 1;
        this.NEAR_BOTTOM_EDGE = 2;
        this.NEAR_LEFT_EDGE = 4;
        this.NEAR_RIGHT_EDGE = 8;
        this.maxLargeTurnDeg = 150;
        this.maxSmallTurnDeg = 10;
        this.maxWiggleDeg = 5;
        // Config options
        this.$options = defaultValues.options;
        this.$bug = null;
        // counters
        this.$smallTurnCounter = 0;
        this.$largeTurnCounter = 0;
        this.$edgeTestCounter = 0;
        this.$toggleStationaryCounter = 0;
        this.$animating = false;
        this.$die = false;
        this.$stationary = false;
        this.$nearEdge = 0;
        this.$angleDeg = 0;
        this.$angleRad = 0;
        this.$largeTurnAngleDeg = 0;
        this._mounted = false;
        // directions
        this.directions = {}; // 0 degrees starts on the East
        var zoom = (Math.random() * (1.5 - 0.8 + 1) + 0.8);
        var walkSpeedTemp = (20 / zoom);
        var walkSpeed = (walkSpeedTemp < 40) ? 40 : ((walkSpeedTemp > 100) ? 100 : walkSpeedTemp);
        this.$options = __assign(__assign(__assign({}, this.$options), options), { zoom: zoom, walkSpeed: walkSpeed });
        this.$bootstrap = bootstrap;
        this.$bootstrap.subscribe(this);
        this.$options.bugScore = this.$options.scoreBase / (this.$options.zoom + this.$options.walkSpeed);
        this.directions[this.NEAR_TOP_EDGE] = 270;
        this.directions[this.NEAR_BOTTOM_EDGE] = 90;
        this.directions[this.NEAR_LEFT_EDGE] = 0;
        this.directions[this.NEAR_RIGHT_EDGE] = 180;
        this.directions[this.NEAR_TOP_EDGE + this.NEAR_LEFT_EDGE] = 315;
        this.directions[this.NEAR_TOP_EDGE + this.NEAR_RIGHT_EDGE] = 225;
        this.directions[this.NEAR_BOTTOM_EDGE + this.NEAR_LEFT_EDGE] = 45;
        this.directions[this.NEAR_BOTTOM_EDGE + this.NEAR_RIGHT_EDGE] = 135;
        this.initialize();
    }
    Bug.prototype.onUpdateScore = function (score) {
        var _this = this;
        if (score >= this.$bootstrap.$maxScore) {
            this.stopAnimation();
            this.dieFrames();
            var removeDebounce = (0, Helpers_1.debounce)(function () {
                _this.remove();
            }, 1000);
            removeDebounce();
        }
    };
    Bug.prototype.initialize = function () {
        this.create();
        this.registerEvents();
    };
    Bug.prototype.create = function () {
        var classNames = "".concat(this.$options.classNames.default, " ").concat(this.$options.classNames.stop);
        var bug = document.createElement('div');
        // renderizar fuera del viewport
        bug.className = classNames;
        bug.style.transform = "scale(".concat(this.$options.zoom, ")");
        bug.style.top = "0px"; // renderizar todos en 0
        bug.style.left = "0px"; // renderizar todos en 0
        bug.style.opacity = "0"; // renderizar en 0
        bug.style.animationDuration = "".concat(this.$options.walkSpeed / 10);
        this.$bug = bug;
    };
    Bug.prototype.registerEvents = function () {
        var _this = this;
        if (this.$bug === null)
            throw new Error("The bug its null, cannot render Null");
        this.$bug.addEventListener("mousedown", function (event) {
            if (!_this.$die) {
                _this.$die = true;
                var delay = (0, Helpers_1.getRandomInRange)(_this.$options.minDelay, _this.$options.maxDelay);
                _this.stopAnimation();
                _this.dieFrames();
                _this.$bootstrap.addScore(1);
                if (_this.$bootstrap.$score < 12) {
                    var deb = (0, Helpers_1.debounce)(function () { return _this.respawn(); }, delay);
                    deb();
                }
            }
        });
    };
    Bug.prototype.respawn = function () {
        this.stopFrames();
        var zoom = (Math.random() * (1.5 - 0.8 + 1) + 0.8);
        var walkSpeedTemp = (20 / zoom);
        var walkSpeed = (walkSpeedTemp < 40) ? 40 : ((walkSpeedTemp > 100) ? 100 : walkSpeedTemp);
        this.$options = __assign(__assign({}, this.$options), { zoom: zoom, walkSpeed: walkSpeed });
        if (!this.$bug)
            this.create();
        if (!this.$bug)
            return;
        this.walkIn();
    };
    Bug.prototype.remove = function () {
        if (this.$bug === null)
            throw new Error("The bug its null, cannot remove Null");
        var body = document.querySelector("body") || document.body;
        body.removeChild(this.$bug);
    };
    Bug.prototype.render = function () {
        if (this.$bug === null)
            throw new Error("The bug its null, cannot render Null");
        if (!this._mounted) {
            this._mounted = true;
            var body = document.querySelector("body") || document.body;
            body.appendChild(this.$bug);
        }
    };
    Bug.prototype.walkIn = function () {
        if (this.$bug === null)
            throw new Error("The bug its null, cannot render Null");
        if (this.$animating)
            this.stopAnimation();
        this.$die = false;
        this.$bug.style.opacity = "1";
        // pick a random side:
        var side = Math.round(Math.random() * 4 - 0.5);
        var windowX = window.innerWidth;
        var windowY = window.innerHeight;
        if (side > 3)
            side = 3;
        if (side < 0)
            side = 0;
        var style = {
            top: 0,
            left: 0,
        };
        if (side === 0) {
            // top:
            style.top = (-1.3 * this.$options.frameHeight);
            style.left = Math.random() * windowX;
        }
        else if (side === 1) {
            // right:
            style.top = Math.random() * windowY;
            style.left = windowX + (1.3 * this.$options.frameWidth);
        }
        else if (side === 2) {
            // bottom:
            style.top = windowY + (1.3 * this.$options.frameHeight);
            style.left = Math.random() * windowX;
        }
        else {
            // left: 
            style.top = Math.random() * windowY;
            style.left = (-1.3 * this.$options.frameWidth);
        }
        this._top = style.top;
        this._left = style.left;
        this.move(this._top, this._left);
        this.render();
        // start walking:
        this.play();
    };
    Bug.prototype.play = function () {
        var _this = this;
        if (this.$bug === null)
            throw new Error("The bug its null, cannot render Null");
        this.$animating = true;
        this.$going = requestAnimationFrame(function (t) {
            _this.animate(t);
        });
    };
    Bug.prototype.move = function (x, y, deg) {
        if (x === void 0) { x = this._left; }
        if (y === void 0) { y = this._top; }
        if (deg === void 0) { deg = this.$angleDeg; }
        if (this.$bug === null)
            throw new Error("The bug its null, cannot render Null");
        // keep track of where we are:
        this._left = x;
        this._top = y;
        // transform:
        var trans = "translate(".concat(x, "px, ").concat(y, "px)");
        if (deg)
            trans += " rotate(".concat(deg, "deg)");
        trans += " scale(".concat(this.$options.zoom, ")");
        this.$bug.style.transform = trans;
    };
    Bug.prototype.animate = function (time) {
        var _this = this;
        if (!this.$bug || this.$animating === false)
            return;
        this.$going = requestAnimationFrame(function (newTime) {
            _this.animate(newTime);
        });
        // reduce counters
        this.$smallTurnCounter -= 1;
        this.$largeTurnCounter -= 1;
        this.$edgeTestCounter -= 1;
        this.$toggleStationaryCounter -= 1;
        // if (!(this._lastTimestamp)) this._lastTimestamp = time;
        var delta = time - (this._lastTimestamp || time);
        this._lastTimestamp = time;
        if (this.$toggleStationaryCounter <= 0) {
            this.$stationary = !this.$stationary;
            this.$toggleStationaryCounter = (0, Helpers_1.getRandomInRange)(20, 40); // stop time
        }
        if (this.$stationary) {
            this.stopFrames();
            return;
        }
        this.walkFrames();
        if (this.$edgeTestCounter <= 0 && this.bugNearWindowEdge()) {
            // if near edge, go away from edge
            this.$angleDeg %= 360;
            if (this.$angleDeg < 0)
                this.$angleDeg += 360;
            if (Math.abs(this.directions[this.$nearEdge] - this.$angleDeg) > 15) {
                var angle1 = this.directions[this.$nearEdge] - this.$angleDeg;
                var angle2 = (360 - this.$angleDeg) + this.directions[this.$nearEdge];
                this.$largeTurnAngleDeg = (Math.abs(angle1) < Math.abs(angle2) ? angle1 : angle2);
                this.$edgeTestCounter = 10;
                this.$largeTurnCounter = 100;
                this.$smallTurnCounter = 30;
            }
        }
        if (this.$largeTurnCounter <= 0) {
            this.$largeTurnAngleDeg = (0, Helpers_1.getRandomInRange)(1, this.maxLargeTurnDeg, true);
            this.$largeTurnCounter = Math.round(Math.random() * 40);
        }
        if (this.$smallTurnCounter <= 0) {
            this.$angleDeg += (0, Helpers_1.getRandomInRange)(1, this.maxSmallTurnDeg);
            this.$smallTurnCounter = Math.round(Math.random() * 10);
        }
        else {
            var dangle = (0, Helpers_1.getRandomInRange)(1, this.maxWiggleDeg, true);
            if ((this.$largeTurnAngleDeg > 0 && dangle < 0) ||
                (this.$largeTurnAngleDeg < 0 && dangle > 0)) {
                dangle = -dangle; // ensures both values either + or -
            }
            this.$largeTurnAngleDeg -= dangle;
            this.$angleDeg += dangle;
        }
        this.$angleRad = (0, Helpers_1.deg2rad)(this.$angleDeg);
        var dx = Math.cos(this.$angleRad) * this.$options.walkSpeed * (delta / 100);
        var dy = -Math.sin(this.$angleRad) * this.$options.walkSpeed * (delta / 100);
        this.move((this._left + dx), (this._top + dy), (90 - this.$angleDeg));
        this.walkFrames();
    };
    Bug.prototype.stopAnimation = function () {
        this.$animating = false;
        if (this.$going) {
            cancelAnimationFrame(this.$going);
            this.$going = null;
        }
    };
    Bug.prototype.dieFrames = function () {
        this.changeSpriteClass(this.$options.classNames.die);
    };
    Bug.prototype.walkFrames = function () {
        this.changeSpriteClass(this.$options.classNames.walk);
    };
    Bug.prototype.stopFrames = function () {
        this.changeSpriteClass(this.$options.classNames.stop);
    };
    Bug.prototype.changeSpriteClass = function (spriteClass) {
        var _this = this;
        if (spriteClass === void 0) { spriteClass = ""; }
        if (this.$bug !== null) {
            Object.values(this.$options.classNames)
                .forEach(function (value) {
                if (value !== spriteClass && _this.$bug !== null && value !== _this.$options.classNames.default) {
                    _this.$bug.classList.remove(value);
                }
            });
            if (!this.$bug.classList.contains(spriteClass)) {
                this.$bug.classList.add(spriteClass);
            }
        }
        else {
            throw new Error("The bug its null, cannot render Null");
        }
    };
    Bug.prototype.bugNearWindowEdge = function () {
        this.$nearEdge = 0;
        if (this.$bug) {
            if (this._top < 50)
                this.$nearEdge |= this.NEAR_TOP_EDGE;
            else if (this._top > document.documentElement.clientHeight - 50)
                this.$nearEdge |= this.NEAR_BOTTOM_EDGE;
            if (this._left < 50)
                this.$nearEdge |= this.NEAR_LEFT_EDGE;
            else if (this._left > document.documentElement.clientWidth - 50)
                this.$nearEdge |= this.NEAR_RIGHT_EDGE;
            return this.$nearEdge;
        }
    };
    return Bug;
}());
exports.default = Bug;
